<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Mutfak Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/Kitchens" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Mutfaklar</span>
        </b-btn>
      </b-col>
    </b-row>

    <form @submit.prevent="AddKitchen">
      <b-form-group class="formgroup" label="Mutfak Adı">
        <b-form-input type="text" v-model="Kitchen.Name" @keypress.enter.prevent="AddKitchen"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Kitchen: {
        Name: ""
      }
    };
  },
  computed: {
    ...mapState(["ButtonSize"])
  },
  methods: {
    async AddKitchen() {
      await this.$store.dispatch("AddLoading", "AddKitchen");

      await Services.Nozich.Send(
        "AddKitchen",
        {
          Kitchen: this.Kitchen
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddKitchen");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Kitchens");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
